<template>
  <div class="set_wrap">
    <el-button type="primary" @click="autoreply" size="small">新建自动回复</el-button>
    <div class="card_list mt-20">
      <el-card class="box-card mt-20" v-for="(item, index) in keywordList">
        <div slot="header" class="clearfix">
          <span>{{item.title}}</span>
        </div>
        <div class="text item">
          <el-form ref="form" label-width="200px" label-position="left">
            <el-form-item label="关键词:">
              <span v-for="items in item.keyword">{{items}}</span>
            </el-form-item>
            <el-form-item label="自动回复：(随机发送):">
              <div class="form_list" v-for="(response_, index_) in item.response">{{index_+1}}.{{response_}}</div>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-button @click="detelkeyword(index)" size="small">删除</el-button>
          <el-button @click="editkeyword(index)" size="small">编辑</el-button>
        </div>
      </el-card>
    </div>
    <autoReplyDialog :visible.sync="autoreplydialog" v-if="autoreplydialog" :editBody="editBody" @changeInint="changeInint"></autoReplyDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import autoReplyDialog from "@/components/dialog/autoReplyDialog.vue";

  export default {
    name: "analyticsOfficialReplyWord",
    components: {
      autoReplyDialog
    },
    data() {
      return {
        autoreplydialog: false,
        page: 1,
        keywordList: [],
        editBody: ''
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.accounts_keyword, {page: this.page})
            .then(response => {
              this.lock = true;
              if (response.data.code == 0) {
                this.keywordList = response.data.list
              } else {
              }
            })
            .catch(response => {
              this.lock = true;
            });
      },
      // 自动回复
      autoreply() {
        this.editBody = '';
        this.autoreplydialog = true;
      },
      detelkeyword(index) {
        this.$confirm('确认删除？', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios
              .post(api.accounts_keyword_delete, {list_id: this.keywordList[index].id})
              .then(response => {
                this.lock = true;
                if (response.data.code == 0) {
                  this.InitFn()
                } else {
                }
              })
              .catch(response => {
                this.lock = true;
              });
        }).catch(() => {
        });
      },
      editkeyword(index) {
        this.editBody = JSON.stringify(this.keywordList[index]);
        this.autoreplydialog = true;
      },
      changeInint(){
        this.InitFn()
      }
    }
  };
</script>
